import CargoComponent from "@/components/cxc/cargos/CargoComponent";
import CargoFormComponent from "@/components/cxc/cargos/CargoFormComponent";

import CargoSinFelComponent from "@/components/cxc/cargos_fel/CargoSinFelComponent";
import AbonoSinFelComponent from "@/components/cxc/abonos_fel/AbonoSinFelComponent";

import AbonoComponent from "@/components/cxc/abonos/AbonoComponent";
import AbonoFormComponent from "@/components/cxc/abonos/AbonoFormComponent";

import CajaComponent from "@/components/cxc/caja/CajaComponent";

import CargoSerieComponent from "@/components/cxc/cargoserie/CargoSerieComponent";
import CargoSerieFormComponent from "@/components/cxc/cargoserie/CargoSerieFormComponent";

import TipoCargoComponent from "@/components/cxc/tipo_cargo/TipoCargoComponent";
import TipoCargoFormComponent from "@/components/cxc/tipo_cargo/TipoCargoFormComponent";

import TipoAbonoComponent from "@/components/cxc/tipo_abono/TipoAbonoComponent";
import TipoAbonoFormComponent from "@/components/cxc/tipo_abono/TipoAbonoFormComponent";

import AbonoSerieComponent from "@/components/cxc/abono_serie/AbonoSerieComponent";
import AbonoSerieFormComponent from "@/components/cxc/abono_serie/AbonoSerieFormComponent";

import CorteCajaComponent from "@/components/cxc/corte_caja/CorteCajaComponent";
import CorteCajaFormComponent from "@/components/cxc/corte_caja/CorteCajaFormComponent";

import CuentasClientesReport from "@/components/cxc/reportes/CuentasClientesReport";

import VentasPedidosReport from "@/components/cxc/reportes/VentasPedidosReport";

import CobrosFormComponent from "@/components/cxc/cobros/CobrosFormComponent";
import CobrosComponent from "@/components/cxc/cobros/CobrosComponent";

import LineaCreditoFormComponent from "@/components/cxc/linea_credito/LineaCreditoFormComponent";
import LineaCreditoComponent from "@/components/cxc/linea_credito/LineaCreditoComponent";

import AsisteLibrosReport from "@/components/cxc/reportes/AsisteLibrosReport";
import CorteGlobalTienda from "@/components/cxc/reportes/CorteGlobalTienda";

import CorteTiendaListComponent from "@/components/cxc/corte_tienda/CorteTiendaListComponent";
import CorteTiendaDetailComponent from "@/components/cxc/corte_tienda/CorteTiendaDetailComponent";


import CuponesAplComponent from "@/components/cat/cupones_apl/CuponesAplComponent";
import CuponesAplFormComponent from "@/components/cat/cupones_apl/CuponesAplFormComponent";


export default [
  { 
    path: "/cxc/cargos/nuevo",
    name: "cxc-cargos-nuevo",
    component: CargoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/cargos/editar/:id/",
    name: "cxc-cargos-editar",
    component: CargoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/cargos/",
    name: "cxc-cargos",
    component: CargoComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/abonos/nuevo",
    name: "cxc-abonos-nuevo",
    component: AbonoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/abonos/editar/:id/",
    name: "cxc-abonos-editar",
    component: AbonoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/abonos/",
    name: "cxc-abonos",
    component: AbonoComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/caja/",
    name: "cxc-caja",
    component: CajaComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/cargo-serie/nuevo",
    name: "cxc-cargo-serie-nuevo",
    component: CargoSerieFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/cargo-serie/:id/editar/",
    name: "cxc-cargo-serie-editar",
    component: CargoSerieFormComponent,
    meta: {
      requiresAuth: true,
      permission: "",
    },
  },
  {
    path: "/cxc/cargo-serie/",
    name: "cxc-cargo-serie",
    component: CargoSerieComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/tipo-cargo/nuevo",
    name: "cxc-tipo-cargo-nuevo",
    component: TipoCargoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/tipo-cargo/editar/:id/",
    name: "cxc-tipo-cargo-editar",
    component: TipoCargoFormComponent,
    meta: {
      requiresAuth: true,
      permission: "",
    },
  },
  {
    path: "/cxc/tipo-cargo/",
    name: "cxc-tipo-cargo",
    component: TipoCargoComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/cargos-fel/",
    name: "cxc-cargos-fel",
    component: CargoSinFelComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/abonos-fel/",
    name: "cxc-abonos-fel",
    component: AbonoSinFelComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/tipo-abono/nuevo",
    name: "cxc-tipo-abono-nuevo",
    component: TipoAbonoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/tipo-abono/editar/:id/",
    name: "cxc-tipo-abono-editar",
    component: TipoAbonoFormComponent,
    meta: {
      requiresAuth: true,
      permission: "",
    },
  },
  {
    path: "/cxc/tipo-abono/",
    name: "cxc-tipo-abono",
    component: TipoAbonoComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/abono-serie/nuevo",
    name: "cxc-abono-serie-nuevo",
    component: AbonoSerieFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/abono-serie/editar/:id/",
    name: "cxc-abono-serie-editar",
    component: AbonoSerieFormComponent,
    meta: {
      requiresAuth: true,
      permission: "",
    },
  },
  {
    path: "/cxc/abono-serie/",
    name: "cxc-abono-serie",
    component: AbonoSerieComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/corte-caja/",
    name: "cxc-corte-caja",
    component: CorteCajaComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/corte-caja/editar/:id",
    name: "cxc-corte-caja-editar",
    component: CorteCajaFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/reporte-cuentas/",
    name: "cxc-reporte-cuentas",
    component: CuentasClientesReport,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/reporte-pedidos/",
    name: "cxc-reporte-pedidos",
    component: VentasPedidosReport,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/cobros/",
    name: "cxc-cobros",
    component: CobrosComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/cobros/:id",
    name: "cxc-cobros-editar",
    component: CobrosFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/linea_credito/",
    name: "cxc-linea_credito",
    component: LineaCreditoComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/linea_credito/:id",
    name: "cxc-linea_credito-editar",
    component: LineaCreditoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/reportes/asistelibro/",
    name: "cxc-reportes-editar",
    component: AsisteLibrosReport,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/reportes/corte-tienda-global/",
    name: "cxc-reportes-corte-tienda-global-editar",
    component: CorteGlobalTienda,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/corte-tienda/",
    name: "cxc-corte-tienda",
    component: CorteTiendaListComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cxc/corte-tienda/:id/",
    name: "cxc-corte-tienda-editar",
    component: CorteTiendaDetailComponent,
    meta: {
      requiresAuth: true,
    },
  },
  
];
